import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import styles from "assets/jss/material-dashboard-react/components/headerLinksStyle.js";
import { getAuthInfo, logout } from "../../store/slices/auth";
import { useTranslation } from "react-i18next";
import { IconButton } from "@material-ui/core";
import Notification from "./Notification";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { SYSTEM_ROLE } from "config/AppConfig";
import PropTypes from "prop-types";
// import { useMedia } from "react-use";



export default function AdminNavbarLinks(props) {
  const { mobileOpen, isMobile } = props;
  const authInfo = useSelector(getAuthInfo);
  // const below768 = useMedia('(max-width: 950px)');

  const Styles = {
    ...styles,
    navItem: {
      margin: '0 0.5rem'
    },
    wrapItems: {
      display: 'flex',
      alignItems: 'center'
    },
    iconButton: {
      padding: '0 12px',
      '& .MuiSvgIcon-root': {
        height: isMobile ? '1em' : '1em',
        width: isMobile ? '1em' : '1em'
      }
    },
    customIcon: {
      '& .MuiSvgIcon-root': {
        height: isMobile ? '1em' : '3em',
        width: isMobile ? '1em' : '3em'
      }
    }
  }
  const useStyles = makeStyles(Styles);
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const signOut = async () => {
    if (authInfo.role === SYSTEM_ROLE.COMPANY) {
      await dispatch(logout());
      history.push("/auth/company/login");
    } else {
      await dispatch(logout());
      history.push("/auth/login");
    }

  };
  return (
    <div className={classes.wrapItems}>
      <Notification mobileOpen={mobileOpen} isMobile={isMobile} />
      <IconButton
        onClick={() => signOut()}
        aria-label={`${t("button.logout")}`}
        aria-controls="long-menu"
        className={classes.iconButton}
        disabled={mobileOpen && isMobile}
      >
        <ExitToAppIcon />
      </IconButton>
    </div>
  );
}

AdminNavbarLinks.propTypes = {
  mobileOpen: PropTypes.bool,
  isMobile: PropTypes.bool
}